<template>
  <vs-popup fullscreen title="Code Step Edit" :active.sync="popupActive" v-if="popupActive">
    <MonacoEditor key="code"
                  suffix="code"
                  ref="monacoCodeEditor"
                  :text_value="codeValue"
                  language="json"
                  theme="vs-light" />
    <vs-button color="dark"
               @click="onSaveCodeStep"
               style="float:left"
               type="line"
               icon-pack="feather"
               icon="icon-save"
               icon-after />
  </vs-popup>
</template>

<script>
import MonacoEditor from '../MonacoEditor.vue'

export default {
  name: 'CodeEditorPopup',

  components: {
    MonacoEditor
  },

  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    codeValue: {
      type: String,
      default: ''
    },
    
  },

  data() {
    return {
      
    }
  },

  computed: {
    popupActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      }
    },
  },

  methods: {

    onCopyCode() {
      this.$emit('copy-code', this.$refs.monacoCodeEditor.getValue())
    },

    onSaveCodeStep() {
      this.$emit('save-code-step', this.$refs.monacoCodeEditor.getValue())
    }
  }
}
</script> 
